export default __webpack_public_path__ + "static/media/newsimplan-icon-en.ee09a356.png";